/* DSL Carousel autoplay — pause-on-hover, respect prefers-reduced-motion */
(function(){
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  document.querySelectorAll("[data-carousel-autoplay]").forEach(function(c){
    var interval = parseInt(c.dataset.carouselInterval, 10) || 6000;
    var slides = c.querySelectorAll(".carousel__slide, .slideshow__slide, [data-slide]");
    if (slides.length < 2) return;
    var i = 0;
    var timer = setInterval(advance, interval);
    function advance(){ i = (i + 1) % slides.length; slides[i].scrollIntoView({behavior: "smooth", block: "nearest", inline: "start"}); }
    c.addEventListener("mouseenter", function(){ clearInterval(timer); });
    c.addEventListener("mouseleave", function(){ timer = setInterval(advance, interval); });
    c.addEventListener("focusin", function(){ clearInterval(timer); });
  });
})();